module.exports = __webpack_public_path__ + "img/WMStitle.6279aa3f.png";